// extracted by mini-css-extract-plugin
export var settingsList = "_3b-0";
export var settingsRow = "_3b-1";
export var warningDot = "_3b-2";